import{useState as e,useEffect as t}from"react";const r=(r,o={delay:1e3})=>{const[a,c]=e(""),{delay:n}=o;return t(()=>{const e=setTimeout(()=>{c(r)},n);return()=>{clearTimeout(e)}},[r,n]),a};export{r as default};
